import App from "./../app.jsx";
import { Navigate, Outlet } from "react-router-dom";
import Home from "../pages/dashboard/dashboard.js";
import Error from "./../pages/error/error.js";
import ExtraError from "./../pages/extra/extra-error.js";
import Login from "./../pages/user/login.js";
import PrivateRoute from "./PrivateRoute";
import ManageStaff from "../pages/staff/manageStaff.js";
import AddStaff from "../pages/staff/AddStaff.js";
import UpdateStaff from "../pages/staff/updateStaff.js";
import UpdatePassword from "../pages/staff/UpdatePassword.jsx";
import ManageCompany from "../pages/compnay/manageCompnay.jsx";
import AddCompany from "../pages/compnay/addcompany.js";
import UpdateCompany from "../pages/compnay/updateCompany.js";
import ManagePaymentProviders from "../pages/paymentProvider/managePaymentProviders.jsx";
import ManageAllergens from "../pages/allergen/manageAllergens.jsx";
import ManagePackages from "../pages/packages/managePackages.jsx";
import AddPackage from "../pages/packages/addPackage.jsx";
import UpdatePackage from "../pages/packages/updatePackage.jsx";
import ManageSmsPackages from "../pages/smsPackages/manageSmsPackages.jsx";
import AddSmsPackage from "../pages/smsPackages/addSmsPackage.jsx";
import UpdateSmsPackage from "../pages/smsPackages/updateSmsPackage.jsx";
import ManageQuotes from "../pages/quotes/manageQuotes.jsx";
import ManageTwilioPlatformConfig from "../pages/twilio/manageTwilioPlatformConfig.jsx";
import ManagePaymentGatewayPlatforms from "../pages/paymentGatewayPlatform/managePaymentGatewayPlatforms.jsx";
import ManageSubscriptionDojoConfig from "../pages/subscriptionDojo/manageSubscriptionDojoConfig.jsx";

const AppRoute = [
  {
    path: "*",
    element: <App />,
    children: [
      {
        path: "user/*",
        element: <Outlet />,
        children: [
          { path: "login", element: <Login /> },
          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "staff/*",
        element: <PrivateRoute />,
        children: [
          { path: "manageStaff", element: <ManageStaff /> },
          { path: "AddStaff", element: <AddStaff /> },
          { path: "UpdateStaff/:UserName", element: <UpdateStaff /> },
          { path: "updatePassword/:UserName", element: <UpdatePassword /> },
          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "company/*",
        element: <PrivateRoute />,
        children: [
          { path: "manageCompany", element: <ManageCompany /> },
          { path: "addCompany", element: <AddCompany /> },
          { path: "updateCompany/:CompID", element: <UpdateCompany /> },
          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "paymentProvider/*",
        element: <PrivateRoute />,
        children: [
          { path: "managePaymentProviders", element: <ManagePaymentProviders /> },
          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "allergen/*",
        element: <PrivateRoute />,
        children: [
          { path: "manageAllergens", element: <ManageAllergens /> },
          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "packages/*",
        element: <PrivateRoute />,
        children: [
          { path: "managePackages", element: <ManagePackages /> },
          { path: "addPackage", element: <AddPackage /> },
          { path: "updatePackage/:packageID", element: <UpdatePackage /> },
          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "smsPackages/*",
        element: <PrivateRoute />,
        children: [
          { path: "manage", element: <ManageSmsPackages /> },
          { path: "add", element: <AddSmsPackage /> },
          { path: "update/:packageID", element: <UpdateSmsPackage /> },
          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "quotes/*",
        element: <PrivateRoute />,
        children: [
          { path: "manageQuotes", element: <ManageQuotes /> },
          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "twilio/*",
        element: <PrivateRoute />,
        children: [
          { path: "platformSettings", element: <ManageTwilioPlatformConfig /> },
          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "paymentGatewayPlatform/*",
        element: <PrivateRoute />,
        children: [
          { path: "managePlatforms", element: <ManagePaymentGatewayPlatforms /> },
          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "subscriptionDojo/*",
        element: <PrivateRoute />,
        children: [
          { path: "settings", element: <ManageSubscriptionDojoConfig /> },
          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "dashboard",
        element: <PrivateRoute />,
        children: [{ index: true, element: <Home /> }],
      },
      {
        path: "/*",
        element: <PrivateRoute />,
        children: [
          { path: "", element: <Navigate to="/dashboard" replace /> },
          { path: "*", element: <Error /> },
        ],
      },
    ],
  },
];
export default AppRoute;
